export default {
    namespaced:true,
    state:{
        isLogin:false,
        userId:null,
        token:null,
        nickName:null,
        serviceInfo:{},
        srcSymbol:"",
        pre_routerId: "",
        searchId: "",
        example:false,
        userAccount:""
    },
    mutations:{
        changeLogin(state,isLogin){
            state.isLogin = isLogin;
        },
        setUserId(state,userId){
            state.userId = userId;
        },
        setExample(state,val){
            state.example = val;
        },
        setUserAccount(state,val){
            console.log(val)
            state.userAccount = val;
        },
        setToken(state,token){
            state.token = token;
        },
        setNickName(state,nickName){
            state.nickName = nickName;
        },
        setServiceInfo(state,info){
            state.serviceInfo = info;
        },
        setsrcSymbol(state,srcSymbol){
            state.srcSymbol = srcSymbol;
        },
        set_preRouterId(state, routerId) {
            state.pre_routerId = routerId;
        },
        set_routerId(state, routerId) {
            state.routerId = routerId;
        },
        set_searchId(state, id) {
            state.searchId = id;
        }
    }
}
